module.exports = __webpack_public_path__ + "static/media/ic_customer_portal.a2fb7966.svg";